import AvalClass from "./AvalClass";
import * as Paths from "../config/paths";
import request from 'superagent';

class Bond {

    static get modelName() {
        return 'Bond'
    }

    constructor(object){
        Object.assign(this, object, {aval_class: new AvalClass(object.aval_class)})
    }

    /**
     * Deletes the Bond from the server.
     * @returns {Promise<any>}
     */
    deleteBond(){
        const url = `${Paths.URL_BONDS}/${this.id}`;

        return new Promise((resolve, reject) => {
            request.delete(url)
                .set('Access-Control-Allow-Origin', '*')
                .set('accept', 'application/json')
                .set('Authorization', sessionStorage.getItem('auth_token'))
                .parse(({body}) => body)
                .end((err, res) => {
                    if (err){
                        reject(err);
                    }
                    resolve(res);
                });
        });
    }
}

export default Bond;
